import { Button, Skeleton, Tag } from 'antd';
import { capitalize, uniq } from 'lodash';
import { useContext } from 'react';
import ErrorMessage from '../../../components/ErrorMessage';
import ClassAvatar from '../../../components/images/ClassAvatar';
import { ClassMgmtIcon } from '../../../components/images/NavIcons';
import { useCurriculaWithProgressFiltered } from '../../../dataSource/metrics';
import UiContext from '../../../lib/UiContext';
import { getEnv } from '../../../environment/resolve';
const ClassInfoHeader = ({
  ChildComponent
}) => {
  const uiContext = useContext(UiContext);
  const {
    isError,
    isPending,
    data: curricula
  } = useCurriculaWithProgressFiltered(uiContext.entity.students.map(s => ['User', s.id]));
  if (isPending) {
    return <Skeleton />;
  }
  if (isError) {
    return <ErrorMessage message="There was an error during loading app data. Reload the page to try again." />;
  }
  const queryParams = {
    id: uiContext.entity.id,
    startDate: uiContext.dateSpan.from.format('YYYY-MM-DD'),
    endDate: uiContext.dateSpan.to.format('YYYY-MM-DD')
  };
  const menu = [{
    key: 'overview',
    title: 'Overview',
    link: {
      pathname: `/reports/class/overview`,
      query: queryParams
    }
  }, {
    key: 'usage-tab',
    title: 'Usage',
    children: [{
      key: 'usage',
      title: 'Usage Summary',
      link: {
        pathname: `/reports/class/usage`,
        query: queryParams
      }
    }, {
      key: 'attendance',
      title: 'Attendance Report',
      link: {
        pathname: '/reports/class/attendance',
        query: queryParams
      }
    }]
  }, {
    key: 'activity-log',
    title: 'Activity Log',
    children: [{
      key: 'activities',
      title: 'All Activities',
      link: {
        pathname: `/reports/class/activities`,
        query: queryParams
      }
    }, {
      key: 'writing',
      title: 'Writing',
      link: {
        pathname: `/reports/class/writing`,
        query: queryParams
      }
    }]
  }, {
    key: 'proficiency',
    title: 'Proficiency (groups)',
    link: {
      pathname: `/reports/class/proficiency`,
      query: queryParams
    }
  }, {
    key: 'growth',
    title: 'Growth',
    link: {
      pathname: `/reports/class/growth`,
      query: queryParams
    }
  }, {
    key: 'progress',
    title: 'Progress',
    children: [{
      key: 'progres-summary',
      title: 'Summary',
      link: {
        pathname: `/reports/class/progress`,
        query: {
          ...queryParams,
          curriculumId: undefined
        }
      }
    }].concat(curricula.map(curriculum => ({
      key: `progres-detail-${curriculum.id}`,
      title: curriculum.name,
      link: {
        pathname: `/reports/class/progress`,
        query: {
          ...queryParams,
          curriculumId: curriculum.id
        }
      }
    })))
  }, {
    key: 'assignmentsMenu',
    title: 'Assignments',
    children: [{
      key: 'create-assignments',
      title: 'Create New',
      link: {
        pathname: '/toolkits/[[...path]]',
        query: {}
      }
    }, {
      key: 'assignments',
      title: 'Assignments Gradebook',
      link: {
        pathname: '/reports/class/assignments-gradebook',
        query: queryParams
      }
    }, {
      key: 'shared-links',
      title: 'Shared Assignments',
      link: {
        pathname: '/reports/class/shared-links',
        query: queryParams
      }
    }]
  }];
  const breadcrumbs = [<>
      {uiContext.entity.school.district.name}, {uiContext.entity.school.district.state.abbreviation}{' '}
      {uiContext.entity.school.district.isMic ? <Tag color="green">MIC</Tag> : null}
    </>, uiContext.entity.school.name];
  const title = <div style={{
    display: 'flex',
    alignItems: 'center',
    gap: 8
  }}>
      <ClassAvatar of={uiContext.entity} />
      <div>
        Class: {uiContext.entity.name}
        <aside style={{
        display: 'flex',
        justifyContent: 'space-between',
        gap: 20
      }}>
          <small style={{
          color: '#8C8C8C',
          fontWeight: 'normal'
        }}>
            Semester: {uiContext.entity.semester}
          </small>
          <small style={{
          color: '#8C8C8C',
          fontWeight: 'normal'
        }}>
            Grade: {uiContext.entity.grade}
          </small>
          <small style={{
          color: '#8C8C8C',
          fontWeight: 'normal'
        }}>
            Class Type: {capitalize(uiContext.entity.type)}
          </small>
        </aside>
      </div>
    </div>;
  const extra = [<Button key="class-mgmt-btn" href={`${getEnv().classManagement}/student_classes/${uiContext.entity.id}`} icon={<ClassMgmtIcon style={{
    verticalAlign: 'middle'
  }} />} children="Class Management" />];
  const props = {
    menu,
    breadcrumbs,
    title,
    extra
  };
  return <ChildComponent {...props} data-sentry-element="ChildComponent" data-sentry-component="ClassInfoHeader" data-sentry-source-file="Class.jsx" />;
};
export default ClassInfoHeader;